"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onTimeUpdate;
function onTimeUpdate(ev) {
  var playerDuration = this.duration;
  if (playerDuration > 0) {
    for (var i = 0; i < this.buffered.length; i++) {
      var endTime = this.buffered.end(i);
      if (endTime > this._buffer.end) {
        this._buffer.end = endTime;
      }
    }
    // bufferedPercent is rounded to the nearest 10% to prevent updates from being sent too frequently
    var bufferedPercent = Math.round(this._buffer.end / playerDuration * 10) / 10;
    if (bufferedPercent !== this._buffer.percent) {
      this._buffer.percent = bufferedPercent;
      this.emit('bufferedpercent', {
        percent: this._buffer.percent
      });
    }
  }

  // Binds the default timeupdate event if no timeUpdateInterval is provided
  if (!this.config.hasOwnProperty('timeUpdateInterval') || typeof this.config.timeUpdateInterval !== 'number') {
    this.emit('timeupdate', ev);
  }
}